export function getRequestStatusOptions(withDraft?: boolean) {
  return [
    ...(withDraft ? [{ label: 'Draft', value: 'draft' }] : []),
    { label: 'In preparation', value: 'new' },
    { label: 'In progress', value: 'in_progress' },
    { label: 'Waiting Approval', value: 'waiting_approval' },
    { label: 'Approved', value: 'approved' },
    { label: 'Needs attention', value: 'needs_attention' },
    { label: 'Completed', value: 'completed' },
    { label: 'Cancelled', value: 'cancelled' },
  ];
}

export function getRequestStatusLabel(value: string) {
  return getRequestStatusOptions(true).find((item) => item.value === value)?.label;
}

/**
 * Status options grouped into "Open" and "Closed" for the request list filter.
 * Each group header toggles all of its statuses at once.
 */
export function getRequestStatusFilterGroups() {
  return [
    {
      type: 'group' as const,
      key: 'status-open',
      title: 'Open',
      toggleAll: true,
      children: [
        { label: 'In preparation', value: 'new' },
        { label: 'In progress', value: 'in_progress' },
        { label: 'Waiting Approval', value: 'waiting_approval' },
        { label: 'Approved', value: 'approved' },
        { label: 'Needs attention', value: 'needs_attention' },
      ],
    },
    { type: 'divider' as const },
    {
      type: 'group' as const,
      key: 'status-closed',
      title: 'Closed',
      toggleAll: true,
      children: [
        { label: 'Completed', value: 'completed' },
        { label: 'Cancelled', value: 'cancelled' },
        { label: 'Draft', value: 'draft' },
      ],
    },
  ];
}
